<template>
  <div class="about-container">
    <div class="container">
      <img class="title" src="../assets/about-direct-school-title.svg" />
      <nav>
        <router-link to="/about/direct-schools/nantun">南屯校</router-link>
        <router-link to="/about/direct-schools/west-1"
          >西區校 國⼩部</router-link
        >
        <router-link to="/about/direct-schools/west-2"
          >西區校 國中部/高中部</router-link
        >
        <router-link to="/about/direct-schools/xitun">西屯校</router-link>
      </nav>
      <Divider class="divider" />
    </div>
    <router-view />
  </div>
</template>

<script>
import Divider from "@/components/Divider.vue";

export default {
  components: {
    Divider
  }
};
</script>

<style lang="scss" scoped>
.about-container {
  > .container {
    max-width: 848px;
    margin: auto;
  }

  .title {
    display: block;
    margin: 80px auto;
    width: 165px;
  }

  nav {
    display: grid;
    grid-template-areas: ". . . .";
    grid-gap: 40px;
    justify-content: center;

    a {
      background-color: #f3f3f4;
      border-radius: 14px;
      text-decoration: none;
      color: #6b6b6b;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 40px;

      &.router-link-active,
      &:hover {
        background-color: #c4cb7a;
        color: white;
      }
    }
  }

  .divider {
    margin: 30px auto;
  }
}

@media (max-width: 1023px) {
  .title {
    margin: 20px auto !important;
  }

  nav {
    grid-gap: 9px !important;

    a {
      font-size: 12px !important;
      padding: 9px 11px !important;
      min-width: 70px !important;
      box-sizing: border-box;
      text-align: center;
    }
  }

  .divider {
    margin: 12px 5px !important;
  }
}
</style>
